import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";

import { Chart } from "react-chartjs-2";
import { getAllStories } from "../../../../api/summaryReport";


import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  LineElement,
  LineController,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  LineElement,
  LineController,
  PointElement,
  Tooltip,
  Legend
);

const TaskStatus = () => {
  const [chartData, setChartData] = useState(null);
  

  useEffect(() => {
    const token = localStorage.getItem("token");

    getAllStories(token).then((res) => {
      const stories = res.data;

      const today = new Date();

      // Find active sprint (today must be between start and end)
      let activeSprint = null;

      stories.forEach((s) => {
        if (!s.sprint || !s.sprint.startDate || !s.sprint.endDate) return;

        const start = new Date(s.sprint.startDate);
        const end = new Date(s.sprint.endDate);
        end.setHours(23, 59, 59, 999);

        if (today >= start && today <= end) {
          activeSprint = s.sprint;
        }
      });

      if (!activeSprint) {
        console.warn("No active sprint found.");
        return;
      }

      //  Get stories only for the active sprint
      const sprintStories = stories.filter(
        (s) => s.sprint && s.sprint.id === activeSprint.id
      );

      //Build day-by-day labels from sprint start to end 
      const parseDate = (dateStr) => {
        const [year, month, day] = dateStr.split("-").map(Number);
        return new Date(year, month - 1, day);
      };

      const days = [];
      const cursor = parseDate(activeSprint.startDate);
      const endDate = parseDate(activeSprint.endDate);
      cursor.setHours(0, 0, 0, 0);
      //  endDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      while (cursor <= endDate) {
        days.push(new Date(cursor));
        cursor.setDate(cursor.getDate() + 1);
      }

      const totalDays = days.length;
      const labels = days.map((_, i) => `Day ${i + 1}`);
      console.log("Total days:", days.length);
      console.log("Last day:", days[days.length - 1].toLocaleDateString("en-CA"));

      // Calculate total story points for the sprint
      const totalPoints = sprintStories.reduce(
        (sum, s) => sum + (s.storyPoints || 0),
        0
      );

      // Ideal burndown line (linear decrease each day)
      const pointsPerDay = parseFloat((totalPoints / (totalDays - 1 || 1)).toFixed(2));

      const idealData = days.map((_, i) =>
        Math.max(0, parseFloat((totalPoints - pointsPerDay * i).toFixed(2)))
      );

      // Completed story points per day 
      // Only counts stories that are COMPLETED and have a completedDate
      const completedPerDay = days.map((day) => {
        const dayStr = day.toLocaleDateString("en-CA");
        return sprintStories
          .filter(
            (s) => s.status === "COMPLETED" && s.completedDate === dayStr
          )
          .reduce((sum, s) => sum + (s.storyPoints || 0), 0);
      });

      // Remaining effort - stops after last completed day
      let remaining = totalPoints;
      const remainingData = days.map((day, i) => {
         if (day > today) return null;
        const dayStr = day.toLocaleDateString("en-CA");
        const doneToday = sprintStories
          .filter(
            (s) => s.status === "COMPLETED" && s.completedDate === dayStr
          )
          .reduce((sum, s) => sum + (s.storyPoints || 0), 0);
        remaining -= doneToday;
        return remaining;
      });
      console.log("Remaining Data:", remainingData);
      console.log("Completed Per Day:", completedPerDay);

      //  Set chart data
      setChartData({
        labels,
        datasets: [
          {
            type: "bar",
            label: "Completed",
            data: completedPerDay,
            backgroundColor: "rgba(216, 107, 76, 0.65)",
            barThickness: 14,
            order: 1,
            yAxisID: "completedAxis",
          },
          {
            type: "line",
            label: "Ideal",
            data: idealData,
            borderColor: "#9bd1c7",
            tension: 0.4,
            pointRadius: 6,
            borderWidth: 3,
            yAxisID: "effortAxis",
            order: 3,
            clip: false,
          },
          {
            type: "line",
            label: "Remaining Effort",
            data: remainingData,
            borderColor: "#7b8591",
            tension: 0.4,
            pointRadius: 4,
            borderWidth: 3,
            yAxisID: "effortAxis",
            order: 4,
            clip: false,
            spanGaps: false,
          },
        ],
      });
    });
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "bottom" ,
      onClick: () => {},
      },
      tooltip: { mode: "index", intersect: false },
    },
    scales: {
      effortAxis: {
        type: "linear",
        position: "left",
        beginAtZero: true,
        min: 0,
        grace: "5%",
        title: { display: true, text: "Ideal / Remaining Effort (pts)" },
      },
      completedAxis: {
        type: "linear",
        position: "right",
        beginAtZero: true,
        grid: { drawOnChartArea: false },
        title: { display: true, text: "Completed (pts)" },
      },
      x: { grid: { display: false } },
    },
  };

  return (
    <Card className="p-3">
      <h6 className="text-center mb-3">
        Ideal, Remaining Effort and Completed Tasks
      </h6>
      <div style={{ height: "280px" }}>
        {chartData ? (
          <Chart type="bar" data={chartData} options={options} />
        ) : (
          <p className="text-center text-muted">Loading chart...</p>
        )}
      </div>
    </Card>
  );
};

export default TaskStatus;

